import { API } from "aws-amplify";

export const GET_MODEM_USAGE_REQUEST =
    "@@modemUsage/GET_MODEM_USAGE_REQUEST";
export const GET_MODEM_USAGE_SUCCESS =
    "@@modemUsage/GET_MODEM_USAGE_SUCCESS";
export const GET_MODEM_USAGE_FAILURE =
    "@@modemUsage/GET_MODEM_USAGE_FAILURE";

export const GET_MODEM_USAGE_POOLS_REQUEST =
    "@@modemUsage/GET_MODEM_USAGE_POOLS_REQUEST";
export const GET_MODEM_USAGE_POOLS_SUCCESS =
    "@@modemUsage/GET_MODEM_USAGE_POOLS_SUCCESS";
export const GET_MODEM_USAGE_POOLS_FAILURE =
    "@@modemUsage/GET_MODEM_USAGE_POOLS_FAILURE";

export function getUnitModemUsage(id) {
    return async (dispatch) => {
        dispatch({
            type: GET_MODEM_USAGE_REQUEST,
        });
        try {
            let url = `/unit/${id}/modem_usage`;
            const response = await API.get("cmsAPI", url);
            dispatch({
                type: GET_MODEM_USAGE_SUCCESS,
                payload: response,
            });
        } catch (error) {
            dispatch({
                type: GET_MODEM_USAGE_FAILURE,
                payload: error,
            });
        }
    };
}

export function getModemUsagePools() {
    return async (dispatch) => {
        dispatch({
            type: GET_MODEM_USAGE_POOLS_REQUEST,
        });
        try {
            let url = `/modem_usage_pools`;
            const response = await API.get("cmsAPI", url);
            dispatch({
                type: GET_MODEM_USAGE_POOLS_SUCCESS,
                payload: response,
            });
        } catch (error) {
            dispatch({
                type: GET_MODEM_USAGE_POOLS_FAILURE,
                payload: error,
            });
        }
    };
}